module.exports = __webpack_public_path__ + "3d5248245ef56d8e2a9d7bd073a766a8.svg";